import './NavLinks.less';

import React from 'react';
import ArrowRightIcon from 'nike-ui/src/icons/ArrowRightIcon';
import { navigate } from '@/routing';
import i18n from '@i18n';

function NavLinks({ icon, label, route }) {
    return (
        <div
            onClick={() => navigate(route)}
            className="mx-20 flex flex-row items-center nav-links-box br-radius-xs px-15 mb-10 mt-10 pointer"
        >
            <div className="nav-links-label-icon mr-15 mt-3">{icon}</div>
            <div className={'py-10'}>{label}</div>
            <div className="nav-links-arrow p-rel">
                <ArrowRightIcon classname="nav-links-arrow-icon" />
            </div>
        </div>
    );
}

export function setNavLinklabel(name, count, label) {
    if (count === 1) {
        return (
            <span>
                {i18n('common.aktivny') + ' ' + count + ' '}
                {name ? name : label === 'Bonusy' ? i18n('common.bonus') : null}
            </span>
        );
    }
    if (count > 1 && count < 5) {
        return label === 'Turnaje' ? (
            <span>{i18n('common.aktivne') + ' ' + count + ' ' + i18n('common.turnaje')}</span>
        ) : (
            <span>{i18n('common.aktivne') + ' ' + count + ' ' + i18n('common.bonusy')}</span>
        );
    }
    if (count > 4) {
        return label === 'Turnaje' ? (
            <span>{i18n('common.aktivnych') + ' ' + count + ' ' + i18n('common.turnajov')}</span>
        ) : (
            <span>{i18n('common.aktivnych') + ' ' + count + ' ' + i18n('common.bonusov')}</span>
        );
    }
}

export default NavLinks;
